"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _backgroundFilterWebAnalytics = require("./backgroundFilterWebAnalytics");
Object.keys(_backgroundFilterWebAnalytics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _backgroundFilterWebAnalytics[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _backgroundFilterWebAnalytics[key];
    }
  });
});